const state = {
  isShowRegisterForm: false,
  isShowLoginForm: false,
  isShowBuyForm: false,
  isShowDepositForm: false,
  isShowDepositAddressForm: false,
  isShowAmountForm: false,
  isShowDepositSuccessForm: false,
  isShowWaitingForm: false,
  modalData: {
    text: ''
  },
  isShowChangeMatrixForm: false,
  isShowChangePasswordForm: false,
  isShowForgotPasswordForm: false,
  isShowResetPasswordForm: false,
  isShowWalletProviderForm: false,
  isShowVerifyEmailSuccess: true,
  isShowWithdrawForm: false,
  withdrawModalData: {},
  isShow2FAForm: false,
  faData: {},
  isShowRemove2FASuccess: false
}

const getters = {
  faData: state => state.faData,
  isShow2FAForm: state => state.isShow2FAForm,
  isShowWithdrawForm: state => state.isShowWithdrawForm,
  isShowRegisterForm: state => state.isShowRegisterForm,
  isShowLoginForm: state => state.isShowLoginForm,
  isShowBuyForm: state => state.isShowBuyForm,
  isShowDepositForm: state => state.isShowDepositForm,
  isShowDepositAddressForm: state => state.isShowDepositAddressForm,
  isShowAmountForm: state => state.isShowAmountForm,
  isShowDepositSuccessForm: state => state.isShowDepositSuccessForm,
  isShowVerifyEmailSuccess: state => state.isShowVerifyEmailSuccess,
  isShowWaitingForm: state => state.isShowWaitingForm,
  modalData: state => state.modalData,
  withdrawModalData: state => state.withdrawModalData,
  isShowChangeMatrixForm: state => state.isShowChangeMatrixForm,
  isShowWalletProviderForm: state => state.isShowWalletProviderForm,
  isShowChangePasswordForm: state => state.isShowChangePasswordForm,
  isShowForgotPasswordForm: state => state.isShowForgotPasswordForm,
  isShowResetPasswordForm: state => state.isShowResetPasswordForm,
  isShowRemove2FASuccess: state => state.isShowRemove2FASuccess
}

const mutations = {
  SET_WITHDRAW_MODAL_DATA: (state, data) => {
    state.withdrawModalData = data
  },
  SET_SHOW_WALLET_PROVIDER_FORM: (state, status) => {
    state.isShowWalletProviderForm = status !== undefined ? status : !state.isShowWalletProviderForm
  },
  SET_WAITING_FORM: (state, data) => {
    state.isShowWaitingForm = !state.isShowWaitingForm
  },
  SET_SHOW_DEPOSIT_SUCCESS_FORM: (state, data) => {
    state.isShowDepositSuccessForm = !state.isShowDepositSuccessForm
    data && (state.modalData = data)
  },
  SET_SHOW_CHANGE_MATRIX_FORM: (state) => {
    state.isShowChangeMatrixForm = !state.isShowChangeMatrixForm
  },
  SET_SHOW_AMOUNT_FORM: (state) => {
    state.isShowAmountForm = !state.isShowAmountForm
  },
  SET_DEPOSIT_FORM: (state) => {
    state.isShowDepositForm = !state.isShowDepositForm
  },
  SET_WITHDRAW_FORM: (state) => {
    state.isShowWithdrawForm = !state.isShowWithdrawForm
  },
  SET_DEPOSIT_ADDRESS_FORM: (state) => {
    state.isShowDepositAddressForm = !state.isShowDepositAddressForm
  },
  SET_BUY_IFORM: (state) => {
    state.isShowBuyForm = !state.isShowBuyForm
  },
  SET_REGISTER_FORM: (state) => {
    state.isShowRegisterForm = !state.isShowRegisterForm
    state.isShowBuyForm = !state.isShowBuyForm
  },
  SET_CHANGE_PASS_FORM: (state) => {
    state.isShowChangePasswordForm = !state.isShowChangePasswordForm
  },
  SET_FORGOT_PASS_FORM: (state) => {
    state.isShowForgotPasswordForm = !state.isShowForgotPasswordForm
  },
  SET_RESET_PASS_FORM: (state) => {
    state.isShowResetPasswordForm = !state.isShowResetPasswordForm
  },
  SET_SHOW_VERIFY_EMAIL_SUCCESS_FORM: (state) => {
    state.isShowVerifyEmailSuccess = !state.isShowVerifyEmailSuccess
  },
  SET_SHOW_REMOVE_2FA_FORM: (state) => {
    state.isShowRemove2FASuccess = !state.isShowRemove2FASuccess
  },
  SET_LOGIN_FORM: (state) => {
    state.isShowLoginForm = !state.isShowLoginForm
    state.isShowBuyForm = !state.isShowBuyForm
  },
  SET_2FA_FORM: (state, data) => {
    state.isShow2FAForm = !state.isShow2FAForm
    if (data) state.faData = data
  },
  CLOSE_ALL_MODAL: (state) => {
    state.isShowRemove2FASuccess = false
    state.isShowLoginForm = false
    state.isShowRegisterForm = false
    state.isShowBuyForm = false
    state.isShowDepositForm = false
    state.isShowAmountForm = false
    state.isShowDepositSuccessForm = false
    state.isShowWaitingForm = false
    state.isShowChangeMatrixForm = false
    state.isShowChangePasswordForm = false
    state.isShowWalletProviderForm = false
    state.isShowDepositAddressForm = false
    state.isShowWithdrawForm = false
    state.isShowVerifyEmailSuccess = false
    state.isShowResetPasswordForm = false
    state.isShowForgotPasswordForm = false
  }
}

const actions = {
  setWithdrawModalData ({ commit }, data) {
    commit('SET_WITHDRAW_MODAL_DATA', data)
  },
  toggleWalletProviderForm ({ commit }, status) {
    commit('SET_SHOW_WALLET_PROVIDER_FORM', status)
  },
  toggleStakingSwapForm ({ commit }) {
    commit('SET_STAKING_SWAP_FORM')
  },
  toggleWaitingForm ({ commit }) {
    commit('SET_WAITING_FORM')
  },
  toggleChangeMatrixForm ({ commit }) {
    commit('SET_SHOW_CHANGE_MATRIX_FORM')
  },
  toggleVerifyEmailSuccessForm ({ commit }) {
    commit('SET_SHOW_VERIFY_EMAIL_SUCCESS_FORM')
  },
  toggleDepositSuccessForm ({ commit }, data) {
    commit('SET_SHOW_DEPOSIT_SUCCESS_FORM', data)
  },
  toggleAmountForm ({ commit }) {
    commit('SET_SHOW_AMOUNT_FORM')
  },
  toggleStakingAmountForm ({ commit }) {
    commit('SET_SHOW_STAKING_AMOUNT_FORM')
  },
  toggleIeoForm ({ commit }, selectedBalance) {
    commit('SET_BUY_IFORM')
    selectedBalance && this.dispatch('setSelectedBalance', selectedBalance)
  },
  toggleRegisterFormModal ({ commit }) {
    commit('SET_REGISTER_FORM')
  },
  toggleChangePasswordFormModal ({ commit }) {
    commit('SET_CHANGE_PASS_FORM')
  },
  toggleForgotPasswordFormModal ({ commit }) {
    commit('SET_FORGOT_PASS_FORM')
  },
  toggleResetPasswordFormModal ({ commit }) {
    commit('SET_RESET_PASS_FORM')
  },
  toggleLoginFormModal ({ commit }) {
    commit('SET_LOGIN_FORM')
  },
  toggleDepositForm ({ commit }) {
    commit('SET_DEPOSIT_FORM')
  },
  toggleDepositAddressForm ({ commit }) {
    commit('SET_DEPOSIT_ADDRESS_FORM')
  },
  toggleWithdrawForm ({ commit }) {
    commit('SET_WITHDRAW_FORM')
  },
  toggleRemove2FASuccessForm ({ commit }) {
    commit('SET_SHOW_REMOVE_2FA_FORM')
  },
  toggle2FAForm ({ commit }, data) {
    commit('SET_2FA_FORM', data)
  },
  closeAllModal ({ commit }) {
    commit('CLOSE_ALL_MODAL')
  }
}

export default { state, getters, mutations, actions }
